export const LINKBUTTON_VARIANTS = ['primary', 'secondary', 'tertiary', 'light', 'link'];
export const LINK_ARIA_ATTRIBUTES = ['aria-label'];
//# sourceMappingURL=link-button-utils.js.map
